import { render, staticRenderFns } from "./RegAlyticsAlertId.vue?vue&type=template&id=32fd9788"
import script from "./RegAlyticsAlertId.vue?vue&type=script&lang=js"
export * from "./RegAlyticsAlertId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports